import styled from 'styled-components';

/**
 * A standard way of showing errors.
 */
export const ErrorMessage = styled.span`
    color: var(--color-feedback-error-text);
`;
